<div class="flex flex-1 w-full h-full justify-center items-center">
    <div class="flex basis-3/6 rounded-lg bg-white lg:h-[85%]">
        <div class="flex flex-col w-full p-8 gap-8">
            <div class="flex flex-col w-full">
                <h3 class="text-xl font-bold">General Information</h3>
                <div class="flex flex-wrap gap-4 mt-4">
                    <zt-textinput
                        [config]="firstNameConfig"
                        [value]="currentUser?.firstName ?? ''"
                        [disabled]="true"
                    ></zt-textinput>
                    <zt-textinput
                        [config]="lastNameConfig"
                        [value]="currentUser?.lastName ?? ''"
                        [disabled]="true"
                    ></zt-textinput>
                    <zt-textinput
                        [config]="emailConfig"
                        [value]="currentUser?.email ?? ''"
                        [disabled]="true"
                    ></zt-textinput>
                </div>
            </div>
            <div class="flex flex-col w-full">
                <h3 class="text-xl font-bold">License Information</h3>
                <div class="flex flex-wrap gap-4 mt-4">
                    <span class="inline-flex">
                        <zt-textinput
                            [config]="apiKeyConfig"
                            [value]="license?.key ?? ''"
                            [disabled]="true"
                            [hideChars]="true"
                            [hasHideIcon]="true"
                            [hasCopyIcon]="true"
                        ></zt-textinput>
                    </span>
                    <zt-textinput
                        [config]="apiKeyRemCharsConfig"
                        [value]="license?.remainingChar?.toString() ?? ''"
                        [disabled]="true"
                    ></zt-textinput>
                    <zt-textinput
                        [config]="apiKeyExpiringDateConfig"
                        [value]="license?.expiringDate ?? ''"
                        [disabled]="true"
                    ></zt-textinput>
                </div>
            </div>
            <div class="flex flex-col w-full">
                <h3 class="text-xl font-bold">Password Information</h3>
                <form
                    class="mt-4"
                    (submit)="onSubmitListener($event)"
                    [formGroup]="changePasswordForm"
                >
                    <div class="flex flex-wrap gap-4">
                        <zt-textinput
                            [config]="newPassConfig"
                            [control]="newPassControl | formControl"
                            [hideChars]="true"
                            [hasHideIcon]="true"
                        ></zt-textinput>
                        <zt-textinput
                            [config]="confirmNewPassConfig"
                            [control]="confirmPassControl | formControl"
                            [hideChars]="true"
                            [hasHideIcon]="true"
                        ></zt-textinput>
                        <div class="flex basis-full">
                            <zt-button
                                [config]="saveBtnConfig"
                                [type]="ZtButtonType.PRIMARY"
                                (onClick)="changePassword()"
                            ></zt-button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
